import Chart from 'chart.js';

import {CHART_COLORS_DISCRETE_PALETTE} from 'ui-library/charting/internals/utils/Theme';

export function getBaseChartOptions(datasets: Array<{label?: string}>): Chart.ChartOptions {
  return {
    animation: {
      duration: 0,
    },
    legend: {
      display: datasets.some(({label}) => label),
    },
    maintainAspectRatio: false,
  };
}

type BaseChartData<XType> = Array<{x: XType}>;

interface BaseChartDataset<XType> {
  data: BaseChartData<XType>;
}

export function getAllXValues<XType>(datasets: Array<BaseChartDataset<XType>>): Array<XType> {
  return datasets.flatMap(({data}) => data.map(({x}) => x));
}

export function getDatasetColor(
  datasetIndex: number
): Pick<Chart.ChartDataSets, 'backgroundColor' | 'borderColor'> {
  const colorIndex = datasetIndex % CHART_COLORS_DISCRETE_PALETTE.length;
  const color = CHART_COLORS_DISCRETE_PALETTE[colorIndex];
  return {
    backgroundColor: color,
    borderColor: color,
  };
}
